import { onboardingHubEntryPoint } from '@jira/admin-pages__onboarding-hub/src/onboardingHubEntryPoint.tsx';
import { userSegRedirectEntrypoint } from '@jira/redirect-entrypoints__user-seg-redirect/entrypoint.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { productsOnboardingHubRoute } from '@atlassian/jira-router-routes-admin-pages-onboarding-hub-routes/src/productsOnboardingHubRoute.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { nav4SidebarGlobalProductsSettingsEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-products/entrypoint.tsx';

const productsOnboardingHubEntryPoint = createPageEntryPoint({
	main: onboardingHubEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
	redirect: userSegRedirectEntrypoint,
});

// When a user visits this page directly, the left sidebar comes from
// nav4SidebarGlobalProductsSettingsEntryPoint, but when they land on this page via
// the Global Settings Page Switcher, the left sidebar comes from the relay-resource-backed
// component: SidebarContentWithRelayResource.
// See @atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-products/src/ui/index.tsx.
const productsOnboardingHubWithDelegatedAdminEntryPoint = createPageEntryPoint({
	main: onboardingHubEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
	leftSidebar: {
		sidebar: nav4SidebarGlobalProductsSettingsEntryPoint,
	},
});

export const productsOnboardingHubRouteEntry = createEntry(productsOnboardingHubRoute, () => ({
	group: 'global-settings',

	ufoName: 'global-admin.products.onboarding-hub',

	meta: {
		reporting: {
			id: 'products-onboarding-hub',
			teamName: 'a4t-pandora',
			packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries',
		},
	},

	entryPoint() {
		if (fg('jira-onboarding-hub-gate')) {
			return fg('jira-delegated-custom-onboarding')
				? productsOnboardingHubWithDelegatedAdminEntryPoint
				: productsOnboardingHubEntryPoint;
		}
		return undefined;
	},

	layout: globalSettingsLayout,

	navigation: {
		menuId: MENU_ID.SETTINGS,
		sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
		sidebar: AsyncSidebarGlobalSettingsProducts,
	},

	resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-admin-pages-onboarding-hub-entries/src/productsOnboardingHubRouteEntry.tsx',
			whichExportToUse: 'productsOnboardingHubRouteEntry',
		},

		enabled: true,
	},
}));
